import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { StudentActions } from './StudentActions';

export const getActionColumn = (
  onEdit: (id: string) => void,
  onDelete: (id: string) => void
): GridColDef => ({
  field: 'actions',
  headerName: 'Actions',
  width: 120,
  sortable: false,
  filterable: false,
  disableColumnMenu: true,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params: GridRenderCellParams) => (
    <StudentActions
      id={params.row.id}
      onEdit={onEdit}
      onDelete={onDelete}
    />
  )
});